import React from 'react';
import '../../../../assets/stylesheets/Dialogs/Purchase.scss';
import sapphireIcon from '../../../../assets/images/shop/sapphire.svg'
import {requestExchangeSapphires} from "../../../../store/actionCreators/exchange";
import {useDispatch, useSelector} from "react-redux";
import config from "../../../../config/config";
import {getGlobalAccountId} from "../../../../store/selectors";
import {closeDialog} from "../../../../store/actionCreators/dialog";

const Purchase =({ type, amount, price }) => {
    const dispatch = useDispatch();
    const accountId = useSelector(getGlobalAccountId);

    const doExchange = () => {
        if( type === "sapphires" ) {
            window.open(`${config.SHOP_URL}?id=${accountId}`, "_blank");
            return dispatch(closeDialog());
        }
        dispatch(requestExchangeSapphires({amount: price, changeTo: 'coin'}));
    };

    return (
        <React.Fragment>
            <div className={`purchaseDialog`}>
                <div className={`imgContainer `}>
                    <p className={`purchaseIcon  _${amount}`}></p>
                </div>
                <p className={`amount`}>{amount}</p>
                <div className={`priceContainer`}>
                    <div className={`bottom`} onClick={doExchange}>
                        <img className={`sapphireIcon`} src={sapphireIcon}/>
                        <span className={`price`}>{price}</span>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Purchase;

